<template>
  <!-- IP管理 -->
  <div>
    <app-page>
      <template #fheader>
        <div class="fan-search margin-bottom-8">
          <jr-search2
            ref="searchForm"
            :form-list="formList"
            :search-value.sync="queryForm"
            :loading="loading"
            @search="handleSearch"
            @reset="handleReset"
            trackCode='serviceIPList-1'
          />
        </div>
      </template>
      <template #main="{ height }">
        <jr-table
          :height="height"
          :key="height"
          :loading="loading"
          :tableData="list"
          :tableColumn="tableColumn"
        />
      </template>
      <template #ffooter>
        <pagination
          :total="total"
          :current-page="queryForm.page"
          :size="queryForm.limit"
          :pageSizes="[10]"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
        />
      </template>
    </app-page>

    <!-- 确认/取消确认弹窗 -->
    <!-- <jr-operate-dialog
      :visible.sync="isOperateStateShow"
      :data-obj.sync="operateStateInfo"
      :text-config.sync="textConfig"
      :loading="submitLoading"
      @submit="handleDivideApprovalSubmit"
    /> -->
    <!-- 新增/编辑 -->
    <modify-dialog
      :visible.sync="isModifyShow"
      :is-modify="isModify"
      :current-obj="currentRow"
      @success="getList"
    />
    <!-- 绑定EIP弹窗 -->
    <bind-eip
      :visible.sync="isBindEipShow"
      :current-obj="currentRow"
      @success="getList"
    />
  </div>
</template>

<script>
import { getIpProxyConfigList } from '@/api/service-ip';
import { setStatusColor } from '@/filters/index';
import modifyDialog from './components/modify-dialog';
import bindEip from './components/bind-eip';

const queryFormDefault = {
  page: 1,
  limit: 10,
  ipAddress: '', // IP地址
  macAddress: '', // MAC地址
  remark: '', // 服务商
};

export default {
  name: 'ServiceIpList',
  components: { modifyDialog, bindEip },
  data() {
    return {
      loading: false,
      queryForm: JSON.parse(JSON.stringify(queryFormDefault)),
      list: [],
      total: 0,
      formList: [
        {
          label: 'IP地址',
          prop: 'ipAddress',
          component: 'input',
        },
        {
          label: '服务商',
          prop: 'remark',
          component: 'input',
        },
        {
          label: 'MAC地址',
          prop: 'macAddress',
          component: 'input',
        },
      ],
      tableColumn: [
        { prop: 'id', label: '序号', minWidth: '1' },
        { prop: 'ipAddress', label: 'IP地址', minWidth: '1' },
        { prop: 'macAddress', label: 'MAC地址', minWidth: '1' },
        { prop: 'regionDesc', label: '地域', minWidth: '1' },
        { prop: 'remark', label: '服务商名称', minWidth: '1' },
        { prop: 'bindEcsName', label: '绑定服务器', minWidth: '1' },
        { label: '状态', status: 'status', statusDesc: 'statusDesc', statusColor: (val) => setStatusColor(val, 'serviceIpStatus') },
        {
          label: '操作',
          width: '120px',
          btnGroups: [
            {
              name: '修改',
              plain: true,
              className: ['table-button', 'table-button-primary'],
              trackCode: 'serviceIPList-2',
              click: (row) => this.handleModify(true, row),
            },
            // 状态1绑定 0未绑定
            {
              name: '绑定',
              plain: true,
              className: ['table-button', 'table-button-success'],
              trackCode: 'serviceIPList-3',
              showBtn: (row) => row.status !== 1,
              click: (row) => this.handleOperateBindEip(row),
            },
            // {
            //   name: '解绑',
            //   plain: true,
            //   className: ['table-button', 'table-button-danger'],
            //   trackCode: 'serviceIPList-4',
            //   showBtn: (row) => row.status === 1,
            //   click: (row) => this.handleOperateState(2, row),
            // },
          ],
        },
      ],
      isBindEipShow: false, // 绑定EIP弹窗
      // isOperateStateShow: false, // 操作弹窗
      // textConfig: {}, // 弹窗页面提示文案
      // operateStateInfo: {}, // 启用停用操作参数
      /** ------新增编辑弹窗参数----- */
      isModifyShow: false,
      isModify: false,
      currentRow: {},
      submitLoading: false,
    };
  },
  created() {
    this.getList();
  },
  methods: {
    // 新增/编辑
    handleModify(flag, row = {}) {
      this.isModify = flag;
      this.isModifyShow = true;
      this.currentRow = { ...row };
    },
    // 打开绑定弹窗
    handleOperateBindEip(row) {
      this.currentRow = { ...row };
      this.isBindEipShow = true;
    },
    /**
     * 状态操作
     * operation     操作：1、绑定 2、解绑
    */
    // handleOperateState(operation, row) {
    //   this.operateStateInfo = {
    //     eipInstanceId: row.ipId,
    //     // operation,
    //   };
    //   const list = {
    //     1: {
    //       title: '绑定IP',
    //       messageTip: '是否绑定该IP?',
    //       isPass: true,
    //     },
    //     2: {
    //       title: '解绑IP',
    //       messageTip: '是否解绑该IP',
    //       isPass: true,
    //     },
    //   };
    //   this.textConfig = list[operation] || '-';
    //   this.isOperateStateShow = true;
    // },
    // 操作请求接口
    // async handleDivideApprovalSubmit(params) {
    //   try {
    //     this.submitLoading = true;
    //     await setIpProxyConfigBindEip(params);
    //     this.$message({
    //       message: '操作成功！',
    //       type: 'success',
    //     });
    //     this.submitLoading = false;
    //     this.isOperateStateShow = false;
    //     this.getList();
    //   } catch (error) {
    //     console.log(error);
    //     this.submitLoading = false;
    //   }
    // },
    // 列表查询
    handleSearch(params = {}) {
      this.queryForm = { ...this.queryForm, ...params, page: 1 };
      this.getList();
    },
    // 重置搜索条件
    handleReset() {
      this.queryForm = JSON.parse(JSON.stringify(queryFormDefault));
      this.getList();
    },
    // 分页操作
    handleCurrentChange(page) {
      this.queryForm.page = page;
      this.getList();
    },
    handleSizeChange(limit) {
      this.queryForm.page = 1;
      this.queryForm.limit = limit;
      this.getList();
    },
    // 列表接口请求
    async getList() {
      try {
        const param = { ...this.queryForm };
        this.loading = true;
        this.list = [];
        delete param.timeType;
        const res = await getIpProxyConfigList(param);
        this.total = res.totalCount || 0;
        this.list = res.data || [];
        this.loading = false;
      } catch (error) {
        console.log(error);
        this.loading = false;
        this.list = [];
        this.total = 0;
      }
    },
  },
};
</script>
